import { render, staticRenderFns } from "./MemberServices.vue?vue&type=template&id=2da54e61&scoped=true&"
import script from "./MemberServices.vue?vue&type=script&lang=js&"
export * from "./MemberServices.vue?vue&type=script&lang=js&"
import style0 from "./MemberServices.vue?vue&type=style&index=0&id=2da54e61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da54e61",
  null
  
)

export default component.exports